// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;If I climb up to heaven, you are there;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;if I make the grave my bed, you are there also.<br> </p> </div></div>";
// Exports
module.exports = code;